import React, { Component } from "react";
import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import InnerHTML from "../../utilities/innerHtml";
import { Div, Text, Row, Col, Input } from "atomize";
import PrimaryButton from "../common/PrimaryButton";
import ImageLazyLoad from "../common/ImageLazyLoad";

import { updateActiveCampaignForm } from "../../utilities/helpers";
import SolutionsPagesButton from "../common/SolutionsPagesButtons";

export default class InfluencerContentHero extends Component {
  render() {
    const { content, form } = this.props;
    return (
      <Div className="curated-hero solutions">
        <ImageLazyLoad
          bgImg={content.img}
          bgSize="cover"
          bgPos={{ xs: "80%", lg: "center" }}
          h={{ xs: "31.25rem", md: "37.8rem" }}
          pos="relative"
        >
          <Div
            h={{ xs: "100%", md: "0" }}
            bg="linear-gradient(180deg, rgba(0,0,0,0.23) 21%, rgba(0,0,0,0.76) 78%)"
          >
            <Div pos="absolute" bottom="3rem" left="0" w="100%">
              <WebsiteContainer>
                <CustomContainer>
                  <Row>
                    <Col
                      size={{ xs: "12", md: "6" }}
                      // p={{ x: { xs: "0", md: "calc(10px)" } }}
                    >
                      <Div
                        pos="relative"
                        // p={{ l: { xs: "0", md: "1.75rem" } }}
                      >
                        {/* <Div
                          w="0.6rem"
                          h="100%"
                          d={{ xs: "none", md: "block" }}
                          pos="absolute"
                          top="0"
                          left="0"
                          bg="linear-gradient(251deg, #FFF7E3 0%, #EDD9AB 100%)"
                        /> */}
                        <Div>
                          <Text
                            textAlign={{ xs: "center", md: "left" }}
                            textSize={{ xs: "caption4", md: "display2" }}
                            textWeight="700"
                            className="hero-text"
                            m={{ t: "-4px", r: { md: "2rem" } }}
                            tag="h1"
                          >
                            {content.heading}
                          </Text>
                          <Text
                            style={{ lineHeight: "28px" }}
                            textAlign={{ xs: "center", md: "left" }}
                            textSize={{ xs: "17px", md: "subheader1" }}
                            m={{ t: "0.1rem", b: { xs: "1.5rem", md: "0" } }}
                            maxW="28rem"
                          >
                            {content.text}
                          </Text>
                        </Div>
                      </Div>
                      <Div m={{ t: "1rem" }}>
                        <SolutionsPagesButton
                          bgColor="primary"
                          textColor="black"
                          hoverBgPrimary="#FFCB6F"
                        />
                      </Div>
                    </Col>
                    <Col size={{ xs: "12", md: "5" }}>
                      {/* <Div
                        d="flex"
                        flexDir="column"
                        justify="flex-end"
                        h="100%"
                        maxW="25rem"
                        m={{ l: "auto" }}
                      >
                        <Text textWeight="700">{content.text2}</Text>
                        <Div m={{ t: "0.675rem" }}>
                          {typeof window !== "undefined" && (
                            <InnerHTML html={updateActiveCampaignForm(form)} />
                          )}
                          
                        </Div>
                      </Div> */}
                    </Col>
                  </Row>
                </CustomContainer>
              </WebsiteContainer>
            </Div>
          </Div>
        </ImageLazyLoad>
      </Div>
    );
  }
}
